import { ExceptionHandler } from "go-core/api/customExceptionHandler";
import { UnprocessableEntity } from "go-core/api/exceptions";
import { ApiError } from "go-core/api/types";

interface DocumentNotChronologicalError extends ApiError {
	document_number?: string;
}

export const exceptionHandlers: ExceptionHandler[] = [
	{
		handle: (exception) => {
			if (!(exception instanceof UnprocessableEntity)) {
				return null;
			}

			const documentNotChronologicalError = exception.errors.find(
				(error) => error.code === "document_not_chronological"
			) as DocumentNotChronologicalError;

			if (!documentNotChronologicalError) {
				return null;
			}

			return [
				{
					...documentNotChronologicalError,
					message: "document_not_chronological",
					code: "document_not_chronological",
					arguments: { document_number: documentNotChronologicalError.document_number },
				},
			];
		},
	},
];
